import script from "./ProductSplashLabels.vue?vue&type=script&lang=ts&setup=true&inherit-attrs=false"
export * from "./ProductSplashLabels.vue?vue&type=script&lang=ts&setup=true&inherit-attrs=false"

import "./ProductSplashLabels.vue?vue&type=style&index=0&id=22df4a82&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22df4a82"]])

export default __exports__